export default "__VITE_ASSET__bQyPj7ML__"